/** Canonical instance IDs are 32-character lowercase hexadecimal strings. */
export function isInstanceId(value: string | undefined): value is string {
  return typeof value === 'string' && /^[a-f0-9]{32}$/.test(value)
}
